import { FEEDBACK_TELEGRAM_LINK } from "@/constants/links";
import Button from "src/components/atoms/Button";
import { useModal } from "src/hooks/useModal";

const CourseBetaModal = () => {
  const { closeModal } = useModal();
  return (
    <div className="flex flex-col space-y-4">
      <p>
        Todos los cursos seran <strong>GRATIS</strong> durante el periodo de
        beta. Estamos trabajando en agregar las siguientes funcionalidades:
      </p>
      <ul className="ml-4 list-inside list-disc">
        <li>Guardar progreso</li>
        <li>Correr todos los ejericios</li>
        <li>Dejar preguntas y comentarios en cada lección</li>
        <li>Solución de los ejercicios</li>
      </ul>
      <p>
        Si tienes alguna sugerencia escribe en el canal de{" "}
        <a href={FEEDBACK_TELEGRAM_LINK} className="text-blue-600 underline">
          Telegram
        </a>{" "}
        y juntos construiremos una mejor plataforma.
      </p>
      <Button
        className="w-full"
        variant="solid"
        color="primary"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          localStorage.setItem("seenBetaModal", "true");
          closeModal();
        }}
      >
        Cerrar
      </Button>
    </div>
  );
};

export default CourseBetaModal;
